import Accordion from "../../../../ui library/components/accordions/Accordion";
import KPIAccordionSummary from "./KPIAccordionSummary";
import KPIAccordionDetails from "./KPIAccordionDetails";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useEffect, useState } from "react";
import useService from "../../../../../hooks/useService";
import { useDashboardRefreshStore } from "../../modules/hooks/useDashboardRefreshStore";

const MetricsContainer = () => {
  const kpiDashboardRepository = useService(
    "repositories/kpi-metric-repository"
  );
  const [expandedAccordions, setExpandedAccordions] = useState([0]);
  const [data, setData] = useState(null);
  const icons = {
    expandIcon: <KeyboardArrowDown className="text-blue-700 text-3xl mx-2" />,
    shrinkIcon: <KeyboardArrowUp className="text-blue-700 text-3xl mx-2" />,
  };

  const fetchKPIData = async () => {
    const kpiData = await kpiDashboardRepository.query({});
    return kpiData;
  };

  const { refreshFlag } = useDashboardRefreshStore();

  useEffect(() => {
    const getData = async () => {
      try {
        const kpiData = await fetchKPIData();
        setData(kpiData);
      } catch (error) {
        return error;
      }
    };
    getData();
  }, [kpiDashboardRepository, refreshFlag]);

  return (
    <div className="bg-white p-2 rounded-[15px] shadow-md w-full h-[45%]">
      <Accordion
        accordionItem={{
          summaryClasses: "bg-white w-full py-2",
          expandedAccordions,
          setExpandedAccordions,
          data: data,
        }}
        icons={icons}
        summaryContent={KPIAccordionSummary}
        expandedContent={<KPIAccordionDetails />}
        index={0}
        expandOnIconClickOnly={false}
        totalExpandedAccordions={{
          expandedAccordions,
          setExpandedAccordions,
        }}
      />
    </div>
  );
};

export default MetricsContainer;
